<div id="row-sets">
  @for (rowSet of get(facetRowSet, 'rowSets', []); track rowSet) {
    <div>
      @for (facet of get(rowSet, 'products.category_top_facets', []); track facet) {
        <div id="products" data-cy="exx-product-category-facet-top">
          @if (get(facet, 'category_title', false)) {
            <div class="d-flex flex-wrap flex-row container-padless category-title">
              <h1 class="col-sm-12 bold">
                {{ facet.category_title }}
              </h1>
            </div>
          }
          @if (!isEmpty(get(facet, 'type_facets', false))) {
            <section class="d-flex flex-wrap container-padless products-type">
              <h3 class="col-sm-12 text-center mb-4">
                {{ get(facet, 'type_facets_title', '') }}
              </h3>
              <div class="col-sm-12 d-flex justify-content-center p-0 type-container">
                <div
                  class="d-flex flex-row type-container type-container-center"
                  (focusin)="revealFocusedFacet($event)"
                  [class.justify-content-center]="get(facet, 'type_facets', []).length <= 2"
                  >
                  @for (type of get(facet, 'type_facets', []); track type) {
                    <div class="right-16">
                      <div class="type-icon-facet d-flex flex-row align-items-center px-2">
                        <a role="link" (click)="filter(get(type, 'link.routerLink', ''), get(type, 'link.queryParams', {}))" data-cy="facet-item" tabindex="0" (keydown.enter)="filter(get(type, 'link.routerLink', ''), get(type, 'link.queryParams', {}))" (keydown.space)="filter(get(type, 'link.routerLink', ''), get(type, 'link.queryParams', {})); $event.preventDefault()">
                          <img [src]="getWebpImg(get(type, 'image.href', ''))" alt="{{ get(type, 'link.title', '') }}" />
                        </a>
                      </div>
                      <p class="type-icon-facet-text text-center">{{ get(type, 'link.title', '') }}</p>
                    </div>
                  }
                </div>
              </div>
            </section>
          }
          @if (!isEmpty(get(facet, 'chipset_screen_facets', false))) {
            <section class="d-flex flex-wrap container-padless flex-row products-type">
              <h3 class="col-sm-12 text-center mb-4">
                {{ get(facet, 'chipset_screen_facets_title', '') }}
              </h3>
              <div class="col-sm-12 p-0">
                <div
                  class="d-flex flex-row type-container type-container-center"
                  (focusin)="revealFocusedFacet($event)"
                  [class.justify-content-center]="get(facet, 'chipset_screen_facets', []).length <= 2"
                  >
                  @for (chip of get(facet, 'chipset_screen_facets', []); track chip) {
                    <div class="right-16 gray-circle">
                      <div class="type-icon-facet-background d-flex flex-column justify-content-center p-1">
                        <a role="link" (click)="filter(get(chip, 'link.routerLink', ''), get(chip, 'link.queryParams', {}))" data-cy="facet-item" tabindex="0" (keydown.enter)="filter(get(chip, 'link.routerLink', ''), get(chip, 'link.queryParams', {}))" (keydown.space)="filter(get(chip, 'link.routerLink', ''), get(chip, 'link.queryParams', {})); $event.preventDefault()">
                          @if (get(chip, 'image.href', '')) {
                            <img [src]="getWebpImg(get(chip, 'image.href', ''))" alt="Chip facet image" />
                          }
                        </a>
                      </div>
                      <p class="text-center">{{ get(chip, 'link.title', '') }}</p>
                    </div>
                  }
                </div>
              </div>
            </section>
          }
          @if (!isEmpty(get(facet, 'logo_facets', []))) {
            <section class="d-flex flex-row flex-wrap container-padless products-type">
              <h3 class="col-sm-12 text-center mb-4">
                {{ get(facet, 'logo_facets_title', '') }}
              </h3>
              <div class="col-sm-12 p-0">
                <div
                  class="d-flex flex-row type-container type-container-center"
                  (focusin)="revealFocusedFacet($event)"
                  [class.justify-content-center]="get(facet, 'logo_facets', []).length <= 2"
                  >
                  @for (logo of get(facet, 'logo_facets', []); track logo) {
                    <div class="right-16">
                      <div class="type-icon-facet fx-row fx-row-v-center px-2">
                        <a role="link" (click)="filter(get(logo, 'link.routerLink', ''), get(logo, 'link.queryParams', {}))" data-cy="facet-item" tabindex="0" (keydown.enter)="filter(get(logo, 'link.routerLink', ''), get(logo, 'link.queryParams', {}))" (keydown.space)="filter(get(logo, 'link.routerLink', ''), get(logo, 'link.queryParams', {})); $event.preventDefault()">
                          @if (get(logo, 'logo_image.href', '')) {
                            <img
                              [src]="getWebpImg(get(logo, 'logo_image.href', ''))"
                              [alt]="get(logo, 'logo_image.title', '')"
                              />
                          }
                        </a>
                      </div>
                      <p class="text-center">{{ get(logo, 'link.title', '') }}</p>
                    </div>
                  }
                </div>
              </div>
            </section>
          }
          @if (!isEmpty(get(facet, 'text_facets', false))) {
            <section class="d-flex flex-row flex-wrap container-padless products-text">
              <h3 class="col-sm-12 text-center mb-4">
                {{ get(facet, 'text_facets_title', '') }}
              </h3>
              <div class="col-sm-12 p-2">
                <div class="d-flex flex-row flex-wrap justify-content-center text-container">
                  @for (text of get(facet, 'text_facets', []); track text) {
                    <div class="mb-2">
                      @if (get(text, 'link.title')) {
                        <button-component
                          data-cy="facet"
                          (click)="filter(get(text, 'link.routerLink', ''), get(text, 'link.queryParams', {}))"
                                [buttonOptions]="{
                                    text: get(text, 'link.title', ''),
                                    type: 'facet'
                                }"
                        ></button-component>
                      }
                    </div>
                  }
                </div>
              </div>
            </section>
          }
        </div>
      }
    </div>
  }
</div>
